import { createFileRoute } from "@tanstack/react-router"
import { LoopReturnsAuthModal } from "modules/settings/components/integrations/loopReturns/LoopReturnsAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/loopReturns/connect")({
  component: LoopReturnsAuthModal,
})
